export default class Image {
    name: string;
    url: string;
    image: string;
    constructor(payload: any) {
        this.name = payload[0];
        this.url = payload[1];
        this.image = payload[2];
    }
}